import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as selectors from '../../selectors/authentication';
import { inputLogin, submitLoginForm } from '../../actions/authentication';
import { bindActionCreators } from 'redux';
import LoginForm from '../../components/application/authentication/LoginForm';
import Flash from '../../components/helpers/Flash';
import { flashMessageSelector, flashOpenSelector, flashTypeSelector } from '../../selectors/application';
import { closeFlash } from '../../actions/global';

class Login extends Component {
    _onSubmit = () => this.props.submitLoginForm(this.props.email, this.props.password);
    _onToggleCheckbox = () => this.props.inputLogin(!this.props.rememberMe, 'rememberMe');
    render() {
        return (
            <React.Fragment>
                <Flash
                    type={this.props.flashType}
                    message={this.props.flashMessage}
                    open={this.props.flashOpen}
                    onClose={this.props.closeFlash}
                />
                <LoginForm
                    email={this.props.email}
                    password={this.props.password}
                    onInput={this.props.inputLogin}
                    onSubmit={this._onSubmit}
                    loading={this.props.loading}
                    errorText={this.props.error}
                    rememberMe={this.props.rememberMe}
                    onChecked={this._onToggleCheckbox}
                />
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    email: selectors.emailSelector(state),
    password: selectors.passwordSelector(state),
    loading: selectors.isSubmittingSelector(state),
    error: selectors.errorSelector(state),
    rememberMe: selectors.rememberMeSelector(state),
    flashMessage: flashMessageSelector(state),
    flashOpen: flashOpenSelector(state),
    flashType: flashTypeSelector(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({ inputLogin, closeFlash, submitLoginForm }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/containers/authentication/Login.js